import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Social from "./components/Social";
import About from "./components/About";
import Accordions from "./components/Accordions";
import TypeWriter from "./components/TypeWriter";
import ImageSwiper from "./components/ImageSwiper";
import Clients from "./components/Clients";
import Share from "./components/Share";
import Footer from "./components/Footer";
import background from "./images/bg.jpeg";
import BottomSwiper from "./components/BottomSwiper";
import HoursAndContact from "./components/HoursAndContact";
import Deals from "./components/Deals";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate your loading process, e.g., fetching data, etc.
    // Once the loading is complete, set loading to false
    setTimeout(() => {
      setLoading(false);
    }, 2500); // Replace with your actual loading logic
  }, []);

  var domainUrl = "https://sovehasmahot.netlify.app/";
  var businessName = "שובע שמחות";
  var businessDescription = "אוכל ביתי איכותי";
  var phoneNumber = "+972549432343";
  var email = "asafz090977@gmail.com";
  var facebookUrl = "https://www.facebook.com/tania.natan";
  var instagram = "tanya_facecare_cosmetics";
  var whatsapp = "+972549432343";
  var wazeUrl =
    "https://www.waze.com/he/live-map/directions/%D7%91%D7%A8%D7%A7%D7%9D?to=place.ws.il.89906.none";
  var days = " א' - ה'";
  var hours = "17:00 - 22:00";

  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };

  return (
    <div className="bg-gray-50 w-full">
      {loading && (
        <div className="preloader">
          <div className="spinner"></div>
        </div>
      )}

      <div className="md:w-4/5 lg:max-w-[1152px] mx-auto shadow-2xl">
        <div className="object-cover">
          <div style={divStyle}>
            <Header
              businessName={businessName}
              businessDescription={businessDescription}
            />

            <Social
              businessName={businessName}
              businessDescription={businessDescription}
              phoneNumber={phoneNumber}
              email={email}
              facebookUrl={facebookUrl}
              instagram={instagram}
              whatsapp={whatsapp}
              wazeUrl={wazeUrl}
              domainUrl={domainUrl}
            />
            <About />

            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
          </div>
          <div style={divStyle}>
            <TypeWriter
              businessName={businessName}
              businessDescription={businessDescription}
            />
            <ImageSwiper />

            <BottomSwiper />
          </div>

          <div style={divStyle}>
            <Deals />
          </div>

          <div style={divStyle}>
            <Clients whatsapp={whatsapp} />
            <HoursAndContact
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
            <Share domainUrl={domainUrl} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
